package com.karyadina.di

import com.karyadina.service.SubscriptionService
import com.karyadina.service.StubSubscriptionService
import io.ktor.client.HttpClient

/**
 * Web/JS implementation - returns stub with all features unlocked
 */
actual fun provideSubscriptionService(httpClient: HttpClient): SubscriptionService {
    return StubSubscriptionService()
}
